import React, { useState } from "react";
import Card from "../UI/Card/Card";
import styles from "./User.module.css";
import Button from "../UI/Button/Button";
import Modal from "../UI/Modal/Modal";
import { useSelector } from "react-redux";
import Loading from "../UI/Loading/Loading";

function UserProfile() {
  const user = useSelector((state) => state.user.userData);

  const [openModal, setOpenModal] = useState(false);

  const handleModal = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  if (openModal) {
    return <Modal closeModal={closeModal} />;
  }

  if (!user) {
    return <Loading />;
  }

  return (
    <div className={styles.userProfile}>
      <h1 className="mb-2 text-pink">Account Detail</h1>
      <Card>
        <div className={styles.info}>
          <p>
            Username: <strong>{user.name}</strong>
          </p>
          <p>
            Mobile: <strong>{user.phone}</strong>
          </p>
          <p>
            Email: <strong>{user.email}</strong>
          </p>
          <p>
            Address: <strong>{user.address}</strong>
          </p>
          <p>
            PIN: <strong>{user.pin}</strong>
          </p>
        </div>
        <div>
          <img src={user.imageUrl} alt="avatar" />
        </div>
      </Card>
      <Button onClick={handleModal} customstyle="btn-primary my-2">
        Update Accout Detail
      </Button>
    </div>
  );
}

export default UserProfile;
